<template>
  <component
    :is="tag"
    v-lazy:background-image="photo"
    class="avatar u-bg-cover"
  >
    <svg-inline>
      <svg
        v-if="!photo"
        width="40"
        height="41"
        viewBox="0 0 40 41"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <text
          fill="#9999A9"
          xml:space="preserve"
          style="white-space: pre"
          font-family="SF Pro Text"
          font-size="14"
          letter-spacing="-0.02em"
          text-anchor="middle"
        >
          <tspan x="20" y="25.4766">{{ initials }}</tspan>
        </text>
      </svg>
    </svg-inline>
  </component>
</template>

<script>
import SvgInline from "@/components/ui-kit/svg-inline/index.vue";

export default {
  components: {
    SvgInline,
  },
  props: {
    tag: {
      type: String,
      default: "div",
    },
    name: {
      type: String,
      required: true,
    },
    photo: {
      type: String,
      default: undefined,
    },
  },
  computed: {
    initials() {
      return this.name?.charAt(0) || "";
    },
  },
};
</script>

<style lang="scss" scoped>
.avatar {
  position: relative;
  background-color: var.$gray-light;
  border-radius: 50%;
}
</style>
